$(document).ready(function() {
    const mailtoLinks = $("a[href^='mailto:']");
    mailtoLinks.click(function(event) {
        event.preventDefault();
        $("#confirmationModal").modal('show');
        const mailtoHref = $(this).attr('href');
        $("#proceedButton").click(function() {
            $("#confirmationModal").modal('hide');
            window.open(mailtoHref, '_blank');
        });
    });
});